export { useFavorites } from "@/context/FavoritesContext";
export type { FavoriteItem } from "@/context/FavoritesContext";
